export var removeDots = function (value) { return value.replace(/\./gu, ''); };
//# sourceMappingURL=removeDots.js.map